import { JSX, useEffect, useMemo } from "react";

import { LinearProgress } from "@mui/material";
import { useAuth } from "react-oidc-context";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { UserAppRole } from "src/constants/userRoles.enum";
import { handleNavigation } from "src/lib/settings.helper";
import { getAppRolesFromUser } from "src/lib/user.helper";

function ProtectedRoute(): JSX.Element | null {
  const navigate = useNavigate();
  const auth = useAuth();
  const location = useLocation();
  const navState = useMemo(() => ({ from: location }), [location]); // <-- current location so login can redirect back is desired

  useEffect(() => {
    const userApiRoles = getAppRolesFromUser(auth.user);
    if (
      !auth.isLoading &&
      auth.isAuthenticated &&
      location.pathname &&
      userApiRoles &&
      userApiRoles.length > 0 &&
      ((location.pathname.includes("/center-dashboard") && !userApiRoles.includes(UserAppRole.MallViewer)) ||
        (location.pathname.includes("/shop-dashboard") && !userApiRoles.includes(UserAppRole.ShopViewer)) ||
        (location.pathname.includes("/station-dashboard") && !userApiRoles.includes(UserAppRole.StationViewer)) ||
        (location.pathname.includes("/files") && !userApiRoles.includes(UserAppRole.DocumentViewer)) ||
        (location.pathname.includes("/extended-analytics") && !userApiRoles.includes(UserAppRole.InsightViewer)) ||
        (location.pathname.includes("/center-region-dashboard") && !userApiRoles.includes(UserAppRole.MallViewer)) ||
        (location.pathname.includes("/shop-region-dashboard") && !userApiRoles.includes(UserAppRole.ShopViewer)) ||
        (location.pathname.includes("/station-region-dashboard") && !userApiRoles.includes(UserAppRole.StationViewer)))
    ) {
      void handleNavigation(userApiRoles, navigate);
    }
  }, [location.pathname, auth.user, auth.isAuthenticated, auth.isLoading, navigate]);

  if (auth.isLoading) {
    return <LinearProgress />;
  }

  if (auth.isAuthenticated) {
    return <Outlet />;
  }

  return <Navigate to='/login' state={navState} />;
}

export default ProtectedRoute;
